import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/',
            name: 'begin',
            component: () => import("./views/login.vue")
        }
    ];
};